export { RouterModule } from './router-module'
export { router } from './router-module'
